module.exports = __webpack_public_path__ + "322e2b50f7372ce51f46c139376ca2b2.png";